<div class="px-3 py-3">
   <mat-card>
      <h1 mat-dialog-title>
         <h3 class="text-muted text-center mb-2">Contrato : {{ contractSelected }}</h3>
      </h1>
      <div mat-dialog-content>
         <table class="table table-bordered">
            <thead>
               <tr>
                  <th>Valor Boleto</th>
                  <th>Número Boleto</th>
                  <th>Vencimento Boleto</th>
                  <th>Index</th>
                  <th>Serviço</th>
                  <th>Conta Corrente</th>
                  <th>Valor C.Corrente</th>
               </tr>
            </thead>
            <tbody>
               <tr *ngFor="let mapping of mappingModel; index as i">
                  <td>{{ mapping.billetValue }}</td>
                  <td>{{ mapping.billetNumber }}</td>
                  <td>{{ mapping.billetDueDate | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ mapping.indexB * 100 }} %</td>
                  <td>{{ mapping.serviceName }}</td>
                  <td>{{ mapping.currentAccountDate | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ mapping.currentAccountValue }}</td>
               </tr>
            </tbody>
         </table>
      </div>
   </mat-card>
</div>
